module.exports = __webpack_public_path__ + "img/DashboardIcon.22d02649.png";